
import { Button, Row, Spin, Select, Tabs, Col, List, Breadcrumb } from 'antd';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { edit } from './lawReportActions';
import queryString from 'query-string';
import SbtComponent from '../sbt/sbtComponent';
import styles from './lawReport.css';

import { selectSbt, nextSbt, prevSbt, firstSbt, lastSbt } from './lawReportActions'

const Option = Select.Option;

class LawReportEditComponent extends Component {

  componentDidMount() {

    // source, options
    this.props.dispatch(edit(this.props.match.params.searchType, this.props.source, this.props.arg));
  }

  selectCategory(index) {

    let arg = Array.isArray(this.props.arg) ? this.props.arg : [this.props.arg];
    arg = arg.slice(0, index + 1);

    const newPath = arg.map((p) => `arg=${p}`);

    document.location.href = document.location.pathname + '?&' + newPath.join('&');
  }

  render() {

    let index = this.props.lawreportEntries.findIndex((e) => e.id === this.props.selectedSbt) + 1;
    let visibilityStyle = { visibility: this.props.lawreportEntries.length > 0 ? 'visible' : 'hidden' }

    return (
      <div>
        <Row>
          <Col span={14}>
            <Row>
              <Breadcrumb style={{marginTop:-10}}>
                <Breadcrumb.Item><a href='#' onClick={() => this.props.history.push('/rattsfall')}>Rättsfall m.m.</a></Breadcrumb.Item>
                {this.props.pathNames.map((p, index) => <Breadcrumb.Item onClick={() => this.selectCategory(index)} key={p}>
                  <a href='#' >{p}</a>
                </Breadcrumb.Item>)}
                <Breadcrumb.Item>{this.props.editTitle}</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row style={styles.pager}>
              <Col span={2} style={visibilityStyle}>
                <Button onClick={() => this.props.dispatch(firstSbt())} icon="double-left" style={{ float: 'left' }}></Button>
                <Button onClick={() => this.props.dispatch(prevSbt())} icon="arrow-left" style={{ float: 'left' }}></Button>
              </Col>
              <Col span={4} style={{ textAlign: 'center', marginTop: 5, ...visibilityStyle }}>
                {index} / {this.props.lawreportEntries.length}
              </Col>
              <Col span={2} style={visibilityStyle}>
                <Button onClick={() => this.props.dispatch(lastSbt())} icon="double-right" style={{ float: 'right' }}></Button>
                <Button onClick={() => this.props.dispatch(nextSbt())} icon="arrow-right" style={{ float: 'right' }}></Button>
              </Col>
            </Row>

          </Col>
          <Col span={10}>
            <Row>

              <Col span={24} style={visibilityStyle}>
                <Select style={{ width: '100%', ...visibilityStyle }} value={this.props.selectedSbt} onChange={(id) => this.props.dispatch(selectSbt(id))}>
                  {this.props.lawreportEntries.map((entry) => (<Option key={entry.id} value={entry.id}>{entry.title}</Option>))}
                </Select>
              </Col>
            </Row>

          </Col>
        </Row>

        <Row>
          <SbtComponent selectedSbt={this.props.selectedSbt} />
        </Row>
      </div>
    )
  }
}


const mapStateToProps = (state, ownProps) => {

  const qs = queryString.parse(ownProps.location.search);

  return {
    loading: state.lawreport.loading,
    arg: qs.arg,
    source: qs.k,
    lawreportEntries: state.lawreport.lawreportEntries,
    pathNames: state.lawreport.pathNames,
    editTitle: state.lawreport.editTitle,
    totalCount: state.lawreport.totalCount,
    selectedSbt: state.lawreport.selectedSbt
  }
};

export default connect(mapStateToProps)(withRouter(LawReportEditComponent));



// WEBPACK FOOTER //
// ./src/lawreport/lawReportEditComponent.js